import { qr_square } from "ui/assets/images";
import { CameraQRReaderDisplayRoot } from "./CameraQRReaderDisplay.styles";
import clsx from "clsx";

export interface CameraQRReaderDisplayProps {
    className?: string;
    style?: React.CSSProperties;
}

function CameraQRReaderDisplay({ className, ...rest }: CameraQRReaderDisplayProps) {
    return (
        <CameraQRReaderDisplayRoot className={clsx("camera-qr-reader-display", className)} {...rest}>
            <img src={qr_square} alt="qr-square" />
        </CameraQRReaderDisplayRoot>
    );
}

export default CameraQRReaderDisplay;
